import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BiData } from '@wix/da-bi/pkg/events';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { useFakeToggleState } from '@wix/da-hooks/pkg/useFakeToggleState';
import { pushUserSettingsModal } from '../../../../Modals/redux/actionCreators';
import { getContentFilter, getShowMatureContent } from '../../../../publicSession/selectors';
import { toggleMature } from '../../../../publicSession/actions';
import SuffixText from '../_partials/SuffixText';
export function useContentFilterItem() {
    const { t } = useTranslation();
    var _useSelector;
    const contentFilter = (_useSelector = useSelector(getContentFilter)) !== null && _useSelector !== void 0 ? _useSelector : 'standard';
    const dispatchPushUserSettingsModal = useAction(pushUserSettingsModal);
    return {
        key: 'content-filter',
        label: t('siteHeader.userMenu.contentFilter'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, t(`siteHeader.userMenu.contentFilter.${contentFilter}`)),
        onClick: dispatchPushUserSettingsModal,
        biData: BiData({
            evid: 702,
            menu_item: 'content_filter',
            menu_name: 'profile',
            toggle_value: contentFilter
        })
    };
}
// note: they kept the old toggle here even after 3 lvls of contentFilter
// were added because they thought it was better to send folks to sisu
//
// This is only used in the logged out menu
export function useFakeContentFilterItem() {
    const dispatchToggleMature = useAction(toggleMature);
    var _useSelector;
    const shouldShowMatureContent = (_useSelector = useSelector(getShowMatureContent)) !== null && _useSelector !== void 0 ? _useSelector : false;
    const { onClick, toggleState } = useFakeToggleState(shouldShowMatureContent);
    const { t } = useTranslation();
    const handleClick = useCallback(()=>{
        onClick();
        dispatchToggleMature(shouldShowMatureContent);
    }, [
        shouldShowMatureContent,
        onClick,
        dispatchToggleMature
    ]);
    return {
        key: 'fake-content-filter',
        label: t('siteHeader.userMenu.matureContent'),
        size: 'medium',
        onChange: handleClick,
        checked: toggleState,
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_mature',
            menu_name: 'profile',
            toggle_value: !shouldShowMatureContent ? 'mature_on' : 'mature_off'
        })
    };
}

//# sourceMappingURL=useContentFilterItem.js.map